import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVisible = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 16C8.84029 16 6.07669 14.4422 4.22645 12.0001C6.07669 9.55785 8.84035 8 12.0001 8C15.1597 8 17.9233 9.55784 19.7736 11.9999C17.9233 14.4421 15.1597 16 11.9999 16ZM12.0001 6C7.85487 6 4.32894 8.2038 2.16794 11.4455C1.94401 11.7814 1.94402 12.219 2.16796 12.5549C4.32895 15.7962 7.85481 18 11.9999 18C16.1451 18 19.6711 15.7962 21.8321 12.5545C22.056 12.2186 22.056 11.781 21.832 11.4451C19.671 8.2038 16.1452 6 12.0001 6ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z",
		fill: "currentColor"
	})
});
export default SvgVisible;
